<script setup>
import { router } from '@inertiajs/vue3';
import { onMounted } from 'vue';
import { reactive } from 'vue';
import JetButton from '@/Jetstream/Button.vue';
import CustomTeamQuestionField from '@/Pages/Teams/Partials/CustomTeamQuestionField.vue';

// includes we need to front end locale magic
import { useI18n } from 'vue-i18n';
// Get locale as set in cookie
let { locale } = useI18n({ useScope: 'global' });
// This needs removing before pushing.

const props = defineProps({
    team: Object,
    loggedInUserId: Number,
    teamAnswers: Array,
    permissions: Object
});

const programme = router.page.props.ziggy.programme;
const organisation = router.page.props.ziggy.organisation;
const urlNamePrefix = organisation ? "gi." : "";
const teamAnswers = props.teamAnswers;
const programme_custom_fields = programme.custom_team_questions;
let organisation_custom_fields = [];
if (organisation) {
    organisation_custom_fields = organisation.custom_team_questions;
}
const custom_questions = programme_custom_fields.concat(organisation_custom_fields);
const team = props.team;
const permissions = props.permissions;

let team_custom_name = programme.team_custom_name;
if (team_custom_name) {
    if(team_custom_name.constructor.name != 'Object') {
        team_custom_name = JSON.parse(team_custom_name);
    }
}

let default_team_name;

if (locale.value == 'cy') {
    default_team_name = 'tîm';

} else  {
    default_team_name = 'team';
}

let team_name = default_team_name;

if (team_custom_name) {
    team_name =  team_custom_name[locale.value] == null ? default_team_name : team_custom_name[locale.value];
}

// Create formData reactive array
const formData = reactive([]);

//Loop through each custom question and build the formData reactive array.
let question_id = 0;
custom_questions.forEach(function (custom_question) {
    formData.push({
        "index_id": question_id,
        "input_type": custom_question.type,
        "question_id": custom_question.id,
        "team_id": team.id,
        "answer": '',
        "required": custom_question.required
    });
    custom_question["index_id"] = question_id;
    question_id++;
});

let formDataItemQuestionID;
let unansweredRequiredQuestions = false;

// Assign answers
formData.forEach(function (formDataItem) {
    formDataItemQuestionID = formDataItem.question_id;

    teamAnswers.forEach(function (teamAnswer) {
        if ( teamAnswer.question_id == formDataItemQuestionID ) {
            if(formDataItem.input_type == 'checkbox') {
                teamAnswer.answer = (teamAnswer.answer == '1' ? 'true' : teamAnswer.answer);
            }
            formDataItem.answer = teamAnswer.answer;
        }
    });
});

const displaySuccessMessage = () => {
    const saveSuccessAlert = document.getElementById('alert-save-success');
    saveSuccessAlert.classList.remove('alert-hidden');
}

const displayErrorMessage = () => {
    const saveErrorAlert = document.getElementById('alert-save-error');
    saveErrorAlert.classList.remove('alert-hidden');
}


// Check for unanswered questions
formData.forEach(function (formDataItem) {
    if ( formDataItem.answer == '' & formDataItem.required == 1) {
     unansweredRequiredQuestions = true;
    }
});

// This is the function that posts updated field data to the database
const UpdateTeamCustomQuestions = ($event) => {

    formData.forEach(function (formDataItem) {
        delete formDataItem.index_id;
    });

    router.post(route(urlNamePrefix+'custom-team-questions.update'),
    {
        formData
    }, {
        preserveState: true,
        preserveScroll: true,
        onSuccess: function() {
            displaySuccessMessage();

        },
        onError: (errors) => {
            displayErrorMessage();
        },

    });

}

onMounted(() => {

    if ( unansweredRequiredQuestions == true ) {
        $('#alert-save-info').removeClass('alert-hidden');
    }

    $('#alert-save-info .alert-close').on('click', function (e) {
    e.preventDefault();
        $('#alert-save-info').addClass('alert-hidden');
    });
    $('#alert-save-success .alert-close').on('click', function (e) {
    e.preventDefault();
        $('#alert-save-success').addClass('alert-hidden');
    });
    $('#alert-save-error .alert-close').on('click', function (e) {
    e.preventDefault();
        $('#alert-save-error').addClass('alert-hidden');
    });
});

</script>
<template>
<div v-if="custom_questions.length !== 0">
    <div class="hidden sm:block"><div class="py-8"><div class="border-t border-gray-200"></div></div></div>

    <div id="alert-save-info" class="p-5 mb-5 bg-blue-100 rounded alert alert-hidden alert-success">
        <div class="flex justify-between">
            <div class="flex space-x-3">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="flex-none w-4 h-4 text-blue-500 fill-current">
                <path d="M12 0c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm-.001 5.75c.69 0 1.251.56 1.251 1.25s-.561 1.25-1.251 1.25-1.249-.56-1.249-1.25.559-1.25 1.249-1.25zm2.001 12.25h-4v-1c.484-.179 1-.201 1-.735v-4.467c0-.534-.516-.618-1-.797v-1h3v6.265c0 .535.517.558 1 .735v.999z" /></svg>
                <div class="flex-1 text-sm font-medium leading-tight text-blue-700">{{ $t('teams.questions.warning') }}</div>
            </div>
            <button class="alert-close">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="flex-none w-3 h-3 text-blue-600 fill-current">
                <path d="M23.954 21.03l-9.184-9.095 9.092-9.174-2.832-2.807-9.09 9.179-9.176-9.088-2.81 2.81 9.186 9.105-9.095 9.184 2.81 2.81 9.112-9.192 9.18 9.1z" /></svg>
            </button>
        </div>
    </div>

    <div id="alert-save-success" class="p-5 mb-5 bg-green-100 rounded alert alert-success alert-hidden">
        <div class="flex justify-between">
            <div class="flex space-x-3">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="flex-none w-4 h-4 text-green-500 fill-current">
                <path d="M12 0c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm-1.25 16.518l-4.5-4.319 1.396-1.435 3.078 2.937 6.105-6.218 1.421 1.409-7.5 7.626z" /></svg>
                <div class="flex-1 text-sm font-medium leading-tight text-green-700">{{ $t('teams.questions.saved') }}</div>
            </div>
            <button class="alert-close">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="flex-none w-3 h-3 text-green-600 fill-current">
                <path d="M23.954 21.03l-9.184-9.095 9.092-9.174-2.832-2.807-9.09 9.179-9.176-9.088-2.81 2.81 9.186 9.105-9.095 9.184 2.81 2.81 9.112-9.192 9.18 9.1z" /></svg>
            </button>
        </div>
    </div>

    <div id="alert-save-error" class="p-5 mb-5 bg-red-100 rounded alert alert-success alert-hidden">
        <div class="flex justify-between">
        <div class="flex space-x-3">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="flex-none w-4 h-4 text-red-500 fill-current">
                <path d="M12 0c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm4.597 17.954l-4.591-4.55-4.555 4.596-1.405-1.405 4.547-4.592-4.593-4.552 1.405-1.405 4.588 4.543 4.545-4.589 1.416 1.403-4.546 4.587 4.592 4.548-1.403 1.416z" /></svg>
                <div class="flex-1 text-sm font-medium leading-tight text-red-700">{{ $t('teams.questions.error') }}</div>
        </div>
        <button class="alert-close">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="flex-none w-3 h-3 text-red-600 fill-current">
            <path d="M23.954 21.03l-9.184-9.095 9.092-9.174-2.832-2.807-9.09 9.179-9.176-9.088-2.81 2.81 9.186 9.105-9.095 9.184 2.81 2.81 9.112-9.192 9.18 9.1z" /></svg>
        </button>
        </div>
    </div>

    <div class="md:grid md:grid-cols-3 md:gap-6">
        <div class="flex justify-between md:col-span-1">
            <div class="px-4 sm:px-0">
                <h3 class="text-lg font-medium text-gray-900"> {{ $t('teams.questions.title') }} </h3>
                <p class="mt-1 text-sm text-gray-600">{{ $t('teams.questions.info', { team_name: team_name }) }}</p>
                <p class="mt-1 text-sm text-gray-600" v-html="$t('teams.questions.required')"></p>
            </div>
            <div class="px-4 sm:px-0"></div>
        </div>
        <div class="mt-5 md:mt-0 md:col-span-2">
            <form @submit.prevent="UpdateTeamCustomQuestions">
                <div class="px-4 py-5 bg-white shadow sm:p-6 sm:rounded-tl-md sm:rounded-tr-md">
                    <div class="grid grid-cols-6 gap-6">
                        <!-- Team Name -->
                        <div class="col-span-6 sm:col-span-4">
                            <div v-if="custom_questions.length !== 0">
                                <CustomTeamQuestionField
                                v-for="custom_question in custom_questions"
                                :custom_question="custom_question"
                                :key="custom_question.index_id"
                                :formData="formData"
                                :datePicker="datePicker" />
                            </div>
                        </div>
                    </div>
                </div>
                <div class="flex items-center justify-end px-4 py-3 text-right shadow bg-gray-50 sm:px-6 sm:rounded-bl-md sm:rounded-br-md">
                    <JetButton
                        type="submit"
                        class="inline-flex items-center px-4 py-2 text-xs font-semibold tracking-widest text-white uppercase transition bg-gray-800 border border-transparent rounded-md hover:bg-gray-700 active:bg-gray-900 focus:outline-none focus:border-gray-900 focus:ring focus:ring-gray-300 disabled:opacity-25"
                        >
                        {{ $t('teams.questions.save') }}
                    </JetButton>
                </div>
            </form>
        </div>
    </div>
</div>

</template>

